<template lang="pug">
.section
  .section-header
    h1 {{ $t("ui.new_website") }}
  .section-body
    .row
      .col-12
        .card.mb-0
          template(v-if="setUpOpAcc == null")
            template(v-if="currentStep == 1")
              WebsiteSetup(ref="websiteSetting" :cartId="cartId" @previousStep="previousStep" @cartValue="getCartId" @goStep="goStep")
            template(v-else-if="currentStep == 2")
              WebsiteColor(ref="websiteColor" :cartId="cartId" @previousStep="previousStep" @goStep="goStep")
            template(v-else-if="currentStep == 3")
              WebsiteReview(ref="websiteReview" :cartId="cartId" @previousStep="previousStep" @goStep="goStep")
          template(v-else-if="setUpOpAcc == true")
            WebsiteOperatorSetup(ref="websiteOperatorSetup" :cartId="cartId")

</template>

<script>
import SubmitButton from "@/library/SubmitButton.vue";
import WebsiteSetup from '@/components/siteeditor/newwebsite/WebsiteSetup.vue';
import WebsiteColor from '@/components/siteeditor/newwebsite/WebsiteColor.vue';
import WebsiteReview from '@/components/siteeditor/newwebsite/WebsiteReview.vue';
import WebsiteOperatorSetup from '@/components/siteeditor/newwebsite/WebsiteOperatorSetup.vue';

export default {
  components: {
    SubmitButton,
    WebsiteSetup,
    WebsiteColor,
    WebsiteReview,
    WebsiteOperatorSetup
  },
  data: () => ({
    currentStep: 1,
    setUpOpAcc: null,
    cartId: null
  }),
  computed: {
    getLanguage() {
      return this.$store.getters.language;
    },
    accountType() {
      return this.$store.getters.accountType;
    },
    isAdmin() {
      return this.$store.getters.accountType === 5;
    },
    isAdminMaster() {
      return [3,5].includes(this.$store.getters.accountType);
    },
    selectedNewWebsite() {
      return this.$store.getters.selectedNewWebsite;
    },
  },
  mounted: function() {
    window.scrollTo(0, 0)
    this.goStep(1);
  },
  destroyed: function() {
    this.$store.dispatch("user/setSelectedNewWebsite", null);
  },
  methods: {
    getCartId(val) {
      this.cartId = val;
    },
    goStep(step, createOp) {
      window.scrollTo(0, 0)
      this.currentStep = step;

      var vm = this
      if(createOp == true) {
        this.setUpOpAcc = this.selectedNewWebsite.setUpOpAcc
      } else {
        if (this.currentStep == 1) {
          $(document).ready(function () {
            if (vm.cartId != null) {
              vm.$refs.websiteSetting.getCartInfo(vm.cartId);
            }
            else {
              vm.$refs.websiteSetting.getThemeList(null);
            }
          });
        }
        else if (this.currentStep == 2) {
          $(document).ready(function () {
            vm.$refs.websiteColor.getCartInfo(vm.cartId);
          });
        }
      }
    },
    previousStep() {
      window.scrollTo(0, 0)
      this.currentStep -= 1;
      var vm = this
      if (this.currentStep == 1) {
        $(document).ready(function () {
          vm.$refs.websiteSetting.getCartInfo(vm.cartId);
        });
      }
      else if (this.currentStep == 2) {
        $(document).ready(function () {
          vm.$refs.websiteColor.getCartInfo(vm.cartId);
        });
      }
    },
    createOperatorStep() {
      this.setUpOpAcc = this.selectedNewWebsite.setUpOpAcc
    }
  }
};
</script>